import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ssl_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function fileUrl(fileId) {
  return `${API}/files/${fileId}?auth=${encodeURIComponent(localStorage.getItem("ssl_token") || "")}`;
}

export function orderPdfUrl(orderId) {
  return `${API}/orders/${orderId}/pdf?auth=${encodeURIComponent(localStorage.getItem("ssl_token") || "")}`;
}

export function apiError(e, fallback = "Ocurrió un error. Intente nuevamente.") {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => (d && d.msg) || JSON.stringify(d)).join(" ");
  }
  return fallback;
}
